import { ClickEvent, Event, Label, Layout, Panel, PanelProps, RowModeControlType, SelectionMode, SelectionType, SlideoutDecorator, TableSelectionEvent } from "@mcleod/components";
import { CancelStopSelection } from "./CancelStopSelection";
import { OrderTabView } from "./OrderTabView";
import { StopList } from "./StopList";

export class CancelStopSelectionSlideout extends Panel {
    private movementId: string;

    constructor(movementId: string, props?: Partial<PanelProps>) {
        super({
            maxWidth: 1100, width: window.innerWidth * .75, height: window.innerHeight,
            backgroundColor: "defaultBackground", top: 30, padding: 0,
            borderRadius: 4, borderWidth: 1, borderShadow: true, borderColor: "strokeSecondary"
        });
        this.movementId = movementId;
    }


    public showSlideout(doAfterClose: (canceled: boolean) => void) {
        if (this.movementId) {
            this.showCancelStopSelection(doAfterClose);
        }
    }

    private showCancelStopSelection(doAfterClose) {
        new SlideoutDecorator({
            layout: Layout.getLayout("lme/dispatch/CancelStopSelection", { fillHeight: true }),
            title: `Rollback Stops - Movement ${this.movementId}`,
            minWidth: "1450",
            layoutLoadListeners: (event: Event) => {
                const layout = event.target as CancelStopSelection;
                const tableStop = (layout.layoutStopList as StopList).tableStop;
                tableStop.selectionMode = SelectionMode.SINGLE;
                tableStop.allowEdit = false;
                tableStop.rowModeControlType = RowModeControlType.AUTO;
                tableStop.fillHeight = true;

                const getSelectedIndex = (selectionEvent: TableSelectionEvent): number | undefined => {
                    const selectedRow = tableStop.selectedRow;
                    const selectedIndex = selectedRow ? tableStop.rows.indexOf(selectedRow) : -1;
                    if (selectedIndex >= 0) {
                        return selectedIndex;
                    }
                    if (selectionEvent.oldIndex == null || tableStop.rows.length === 0) {
                        return undefined;
                    }

                    const replacementIndex = Math.min(selectionEvent.oldIndex + 1, tableStop.rows.length - 1);
                    tableStop.selectRow(tableStop.rows[replacementIndex], SelectionType.SINGLE, null);
                    return replacementIndex;
                };

                const applyRollbackHighlight = (selectedIndex: number | undefined) => {
                    const selectedColor = selectedIndex != null ? tableStop.rows[selectedIndex].backgroundColor : "background";
                    tableStop.rows.forEach((row, index) => {
                        row.backgroundColor = selectedIndex != null && index > selectedIndex ? selectedColor : "background";
                    });
                };

                tableStop.addSelectionListener(event => {
                    const selectedIndex = getSelectedIndex(event as TableSelectionEvent);
                    layout.savebuttonRollback.enabled = selectedIndex != null;
                    applyRollbackHighlight(selectedIndex);
                });
            },
            doAfterSlideIn: async (decorator: SlideoutDecorator) => {
                const layout = (decorator.layout as CancelStopSelection);
                layout.doAfterClose = doAfterClose;
                const stopListLayout = layout.layoutStopList as StopList;
                const response = await stopListLayout.mainDataSource.search({ "movement_id": this.movementId });
                await layout.mainDataSource.search({ "id": this.movementId });
                if (response) {
                    const modelRows = response.modelRows;
                    for (const modelRow of modelRows) {
                        const tableRow = stopListLayout.tableStop.findTableRow(modelRow);
                        const txtOrderId = tableRow.findComponentById("labelOrderId") as Label;
                        const panelManifestOrder = tableRow.findComponentById("panelManifestOrder") as Panel;
                        panelManifestOrder.visible = true;
                        txtOrderId.visible = true;
                        txtOrderId.addUnderlineWhenMouseOver();
                        txtOrderId.addClickListener((event: ClickEvent) => {
                            OrderTabView.navigateTo({ key: modelRow.get("order_id"), newTab: true });
                        });
                    }
                }
            },
            overlayProps: { closeOnClickOff: false, greyedBackground: true }
        });
    }

}
